// @flow
import * as React from "react";
import { useState } from "react";
import Icons from "ui/Icons";
import type { Props as FieldProps } from "ui/molecules/BaseField";
import BaseField from "ui/molecules/BaseField";

import { Input } from "../atoms/Input";

const iconClasses = "text-gray-400 w-6 h-6";

type Props = {
  ...FieldProps,
  type?: "password" | "text",
};

function PasswordField({
  compact,
  horizontal,
  label,
  reverse,
  smallLabel,
  hasError,
  errorLabel,
  type,
  ...rest
}: Props): React.Node {
  const [iconClicked, setIconClicked] = useState(false);

  function performIconClick() {
    setIconClicked(!iconClicked);
  }

  const IconComponent = iconClicked ? (
    <Icons.EyeOff className={iconClasses} />
  ) : (
    <Icons.Eye className={iconClasses} />
  );

  return (
    <BaseField
      semibold
      compact={compact}
      errorLabel={errorLabel}
      hasError={hasError}
      horizontal={horizontal}
      label={label}
      reverse={reverse}
      smallLabel={smallLabel}
    >
      <div className="relative">
        <Input
          {...rest}
          hasError={hasError}
          type={iconClicked ? "text" : "password"}
        />
        <button
          className="absolute p-1 right-0 inset-y-0 pr-3 focus:outline-none"
          onClick={performIconClick}
          type="button"
        >
          {IconComponent}
        </button>
      </div>
    </BaseField>
  );
}

export default PasswordField;
